import { Outlet, useLocation } from 'react-router-dom'
import Starfield from './Starfield'
import LanguageSwitcher from './LanguageSwitcher'
import PageTransition, { sectionKey } from './PageTransition'

const Layout = () => {
    const { pathname } = useLocation()
    // Inside the dashboard the switcher lives in the header bar, so the
    // floating one would sit on top of it doing the same job twice.
    // The landing page carries it in its own header for the same reason.
    const hasOwnSwitcher = pathname.startsWith('/dash') || pathname === '/'

    return (
        <>
            <Starfield />
            {!hasOwnSwitcher && <LanguageSwitcher />}
            <PageTransition transitionKey={sectionKey(pathname)}>
                <Outlet />
            </PageTransition>
        </>
    )
}
export default Layout
